module.exports = __webpack_public_path__ + "img/appAsset--groups-ax.50b58619.svg";